export const ELEMENTS_TO_SEARCH = 10;
